import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "treatment-top" }
const _hoisted_3 = { class: "treatment-top-contents" }
const _hoisted_4 = { class: "treatment-top-title" }
const _hoisted_5 = { class: "treatment-top-caution" }
const _hoisted_6 = { class: "treatment-top-button-wrapper" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "treatment-data-container"
}
const _hoisted_10 = {
  key: 0,
  class: "treatment-empty-container"
}
const _hoisted_11 = { class: "treatment-empty-text" }
const _hoisted_12 = {
  key: 1,
  class: "treatment-data-contents"
}
const _hoisted_13 = { class: "item-top-wrapper" }
const _hoisted_14 = { class: "item-status" }
const _hoisted_15 = { class: "item-status-left" }
const _hoisted_16 = { class: "item-status-left-title" }
const _hoisted_17 = {
  key: 0,
  class: "item-status-left-label suspend"
}
const _hoisted_18 = {
  key: 1,
  class: "item-status-left-label resume"
}
const _hoisted_19 = {
  key: 2,
  class: "item-status-left-label finish"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "pc-only" }
const _hoisted_22 = {
  key: 0,
  class: "item-treatment-detail"
}
const _hoisted_23 = { class: "item-middle-wrapper" }
const _hoisted_24 = { class: "item-middle-left" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 0,
  class: "item-middle-right"
}
const _hoisted_28 = { class: "item-middle-right-text" }
const _hoisted_29 = { class: "item-middle-right-label" }
const _hoisted_30 = { class: "item-bottom-wrapper" }
const _hoisted_31 = { class: "item-period" }
const _hoisted_32 = { class: "item-period-date-wrapper" }
const _hoisted_33 = { class: "item-period-text" }
const _hoisted_34 = {
  key: 0,
  class: "item-period-date"
}
const _hoisted_35 = {
  key: 1,
  class: "item-period-date"
}
const _hoisted_36 = {
  key: 0,
  class: "item-period-date-wrapper"
}
const _hoisted_37 = { class: "item-period-text" }
const _hoisted_38 = { class: "item-period-date" }
const _hoisted_39 = {
  key: 0,
  class: "item-suspend-reason"
}
const _hoisted_40 = { class: "item-suspend-reason-title" }
const _hoisted_41 = {
  key: 0,
  class: "item-suspend-reason-button-wrapper"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "item-update-date" }
const _hoisted_45 = { class: "item-top-wrapper" }
const _hoisted_46 = { class: "item-no-treatment" }
const _hoisted_47 = { class: "item-middle-wrapper" }
const _hoisted_48 = { class: "item-middle-left" }
const _hoisted_49 = { class: "item-bottom-wrapper" }
const _hoisted_50 = { class: "item-no-treatment-note" }

import dayjs from "dayjs";
import "dayjs/locale/ja";
import utc from "dayjs/plugin/utc";

import { computed, ref, onMounted, reactive, nextTick, watch } from "vue";
import { useWindowSize } from "@vueuse/core";
import { useRouter } from "vue-router";
import { _$t } from "@/utils/i18n";

import TreatmentAddEdit from "@/views/pages/MyRecord/Treatment/TreatmentAddEdit.vue";
import TreatmentHistory from "@/views/pages/MyRecord/Treatment/TreatmentHistory.vue";
import ErrorDialog from "@/views/base/CommonMessage.vue";
import Header from "@/components/modules/base/Header.vue";
import Footer from "@/components/modules/base/Footer.vue";
import { Treatment } from "@/models/myRecord/treatment";
import { TreatmentStatus } from "@/models/myRecord/clinicNote/types";
import { processend, processing } from "@/utils/view";

// 日付のローカライズ
type SelectedTreatmentIds = {
  userTreatmentId: number;
  subNumber: number;
};

type TreatmentModalProps = {
  diseaseOptions: { id: string; name: string }[];
  selectedTreatmentIds: SelectedTreatmentIds | null;
};

// --- Constant ------------------------------------------------
const activeMenu = "my-record";
const componentId = "healthcaredata02-02";
const MAX_TREATMENT_COUNT = 50;
const MOBILE_BREAKPOINT = 767;
const PC_REASON_TEXT_COLLAPSE_HEIGHT = 44;
const SP_REASON_TEXT_COLLAPSE_HEIGHT = 64;


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

dayjs.locale("ja");
dayjs.extend(utc);

const treatments = ref([]);
const diseasesWithoutTreatmentRaw = ref([]);
const diseasesWithoutTreatment = computed(() => {
  const treatmentDiseaseCodes = new Set(
    treatments.value.map((item: any) => item?.diseaseCode)
  );

  return diseasesWithoutTreatmentRaw.value.filter(
    (disease: any) => !treatmentDiseaseCodes.has(disease.id)
  );
});
const isInitialized = ref<boolean>(false);
const expandedItems = reactive<{ [key: string]: boolean }>({});
const treatmentBurdenListRefs = reactive<{ [key: string]: any }>({});
const showToggleButtons = reactive<{ [key: string]: boolean }>({});
const { width } = useWindowSize();
const showTreatmentAddModal = ref<boolean>(false);
const showHistoryModal = ref<boolean>(false);
const treatmentModalProps = reactive<TreatmentModalProps>({
  diseaseOptions: [],
  selectedTreatmentIds: null,
});
const router = useRouter();
const treatment = new Treatment();

// --- Functions ------------------------------------------------
const goBack = () => {
  router.back();
};

// 追加編集モーダル開ける
const handleTreatmentModalOpen = (treatment?: any) => {
  showTreatmentAddModal.value = true;
  if (treatment)
    treatmentModalProps.selectedTreatmentIds = {
      userTreatmentId: treatment.userTreatmentId,
      subNumber: treatment.subNumber,
    };
};

// 追加編集モーダル閉じる
const handleTretmentModalClose = () => {
  showTreatmentAddModal.value = false;
  treatmentModalProps.selectedTreatmentIds = null;
};

// 履歴モーダル開ける
const handleHistoryModalOpen = () => {
  showHistoryModal.value = true;
};

// 履歴モーダル閉じる
const handleHistoryModalClose = () => {
  showHistoryModal.value = false;
};

const getReasonTextThreshold = () => {
  return width.value <= MOBILE_BREAKPOINT
    ? SP_REASON_TEXT_COLLAPSE_HEIGHT
    : PC_REASON_TEXT_COLLAPSE_HEIGHT;
};

const shouldShowStatusChangedDate = (statusValue?: number) => {
  return (
    statusValue === TreatmentStatus.Suspend ||
    statusValue === TreatmentStatus.Finish
  );
};

const getStatusChangedDateLabel = (statusValue?: number) => {
  return statusValue === TreatmentStatus.Suspend
    ? _$t("treatment_label_status_suspend")
    : _$t("treatment_label_end");
};

const getStatusChangedDateText = (treatment: any) => {
  const date = treatment?.updatedDate;
  if (!date) return _$t("treatment_label_no_date");
  return dayjs.utc(date).local().format("YYYY年M月D日");
};

const checkTextHeight = (index: string | number): boolean => {
  const element = treatmentBurdenListRefs[index];
  if (element) {
    const shouldShow = element.scrollHeight > getReasonTextThreshold();
    showToggleButtons[index] = shouldShow;
    if (!shouldShow && expandedItems[index]) {
      expandedItems[index] = false;
    }
    return shouldShow;
  }
  return false;
};

//check text height on width change
watch(width, () => {
  nextTick(() => {
    Object.keys(treatmentBurdenListRefs).forEach((key) => {
      checkTextHeight(key);
    });
  });
});

// Toggle expand/collapse for treatment items
const toggleExpand = (index: string | number) => {
  expandedItems[index] = !expandedItems[index];
};

// --- Error handling -----------------------------------------
// セッションエラー判定フラグ
const sessionErr = ref(false);
// エラーダイアログ管理
const errorDialog = reactive({
  show: false,
  okButtonHide: true,
  okName: _$t("survey_msg_ok_btn"),
  safe: true,
  message: "",
  open: (message: string): void => {
    processing(); // オーバレイを表示
    errorDialog.message = message;
    errorDialog.show = true;
  },
  close: (): void => {
    processend(); // オーバレイを非表示
    errorDialog.show = false;
    errorDialog.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});

// 最初のデータ取得
const fetchTreatments = async () => {
  const [_model, response, err] = await treatment.getPageData();
  if (err) {
    const decodedMessage = decodeURIComponent(
      err.error?.response?.data?.message
    );
    const status = err.error?.response?.status;
    if (status === 408) {
      // セッションエラー
      sessionErr.value = true;
    }
    errorDialog.open(decodedMessage);
    return;
  }

  treatments.value = response.data?.treatments;
  diseasesWithoutTreatmentRaw.value = response.data?.noTreatment;
  treatmentModalProps.diseaseOptions = response.data?.diseases;
  isInitialized.value = true;

  // Check heights after rendering
  nextTick(() => {
    Object.keys(treatmentBurdenListRefs).forEach((key) => {
      checkTextHeight(key);
    });
  });
};

// ---- Vue lifeCycle -----------------------------------------
onMounted(() => {
  fetchTreatments();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { id: componentId }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Header, { "active-menu": activeMenu }),
        _createElementVNode("main", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "treatment-top-back-button",
              onClick: goBack
            }, [
              _cache[1] || (_cache[1] = _createElementVNode("img", {
                src: "/server/necs/images/arrow-right_icon.png",
                alt: ""
              }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_label_back")), 1)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("treatment_title")), 1),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("treatment_top_caution", { count: MAX_TREATMENT_COUNT })), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  disabled: !treatments.value.length,
                  class: _normalizeClass(["treatment-top-history-button", { inactive: !treatments.value.length }]),
                  onClick: handleHistoryModalOpen
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_label_history")), 1)
                ], 10, _hoisted_7),
                _createElementVNode("button", {
                  class: "treatment-top-add-button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (handleTreatmentModalOpen())),
                  disabled: treatments.value.length >= MAX_TREATMENT_COUNT
                }, _toDisplayString(_ctx.$t("treatment_label_record")), 9, _hoisted_8)
              ])
            ])
          ]),
          (isInitialized.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (!treatments.value.length && !diseasesWithoutTreatment.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _cache[4] || (_cache[4] = _createElementVNode("img", { src: "/server/necs/images/treatment_empty.png" }, null, -1)),
                      _createElementVNode("p", _hoisted_11, [
                        _createTextVNode(_toDisplayString(_ctx.$t("treatment_label_no_record_1")), 1),
                        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("treatment_label_no_record_2")), 1),
                        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_label_no_record_3")), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(treatments.value, (treatment, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "treatment-data-contents-item",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                  _cache[5] || (_cache[5] = _createElementVNode("img", {
                                    src: "/server/necs/images/icon_treatment_name.svg",
                                    alt: ""
                                  }, null, -1)),
                                  _createElementVNode("p", null, _toDisplayString(treatment.treatment), 1)
                                ]),
                                (
                        treatment.treatmentStatusValue ===
                        _unref(TreatmentStatus).Suspend
                      )
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.$t("treatment_label_status_suspend")), 1))
                                  : _createCommentVNode("", true),
                                (
                        treatment.treatmentStatusValue ===
                        _unref(TreatmentStatus).Resume
                      )
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.$t("myRecord_card_label_reopen")), 1))
                                  : _createCommentVNode("", true),
                                (
                        treatment.treatmentStatusValue ===
                        _unref(TreatmentStatus).Finish
                      )
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.$t("treatment_label_status_finish")), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("button", {
                                class: "item-status-right",
                                onClick: ($event: any) => (handleTreatmentModalOpen(treatment))
                              }, [
                                _cache[6] || (_cache[6] = _createElementVNode("img", {
                                  src: "/server/necs/images/icon_edit_ec7400.svg",
                                  alt: ""
                                }, null, -1)),
                                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("treatment_label_edit")), 1)
                              ], 8, _hoisted_20)
                            ]),
                            (treatment?.treatmentDetail)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(treatment.treatmentDetail), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _cache[7] || (_cache[7] = _createElementVNode("img", {
                                src: "/server/necs/images/stethoscope_24dp_5F6368_FILL1_wght400_GRAD0_opsz24.png",
                                alt: ""
                              }, null, -1)),
                              (treatment?.diseaseName)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(treatment.diseaseName) + _toDisplayString(_ctx.$t("treatment_label_disease_treatment")), 1))
                                : (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.$t("treatment_select_option_no_diseases")), 1))
                            ]),
                            (treatment?.treatmentEffect)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t("treatment_label_effect")), 1),
                                  _createElementVNode("p", _hoisted_29, _toDisplayString(treatment.treatmentEffect), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$t("treatment_label_start")), 1),
                                (treatment?.startDate)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(_unref(dayjs)
                          .utc(treatment.startDate)
                          .local()
                          .format("YYYY年M月D日")), 1))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(_ctx.$t("treatment_label_no_date")), 1))
                              ]),
                              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "item-period-separator" }, "～", -1)),
                              (
                      shouldShowStatusChangedDate(
                        treatment?.treatmentStatusValue
                      )
                    )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                    _createElementVNode("p", _hoisted_37, _toDisplayString(getStatusChangedDateLabel(
                          treatment?.treatmentStatusValue
                        )), 1),
                                    _createElementVNode("p", _hoisted_38, _toDisplayString(getStatusChangedDateText(treatment)), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (treatment?.burdenOfMedicine)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.$t("treatment_label_reason")), 1),
                                  _createElementVNode("p", {
                                    class: _normalizeClass(["item-suspend-reason-text", { expanded: expandedItems[index] }]),
                                    ref_for: true,
                                    ref: (el) => (treatmentBurdenListRefs[index] = el)
                                  }, _toDisplayString(treatment.burdenOfMedicine), 3),
                                  (showToggleButtons[index])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                        (!expandedItems[index])
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              class: "item-suspend-reason-show",
                                              onClick: ($event: any) => (toggleExpand(index))
                                            }, [
                                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_button_display_all")), 1),
                                              _cache[9] || (_cache[9] = _createElementVNode("img", {
                                                src: "/server/necs/images/arrow-right_icon.png",
                                                alt: ""
                                              }, null, -1))
                                            ], 8, _hoisted_42))
                                          : _createCommentVNode("", true),
                                        (expandedItems[index])
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 1,
                                              class: "item-suspend-reason-hide active",
                                              onClick: ($event: any) => (toggleExpand(index))
                                            }, [
                                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_button_close")), 1),
                                              _cache[10] || (_cache[10] = _createElementVNode("img", {
                                                src: "/server/necs/images/arrow-right_icon.png",
                                                alt: ""
                                              }, null, -1))
                                            ], 8, _hoisted_43))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_44, [
                              _cache[11] || (_cache[11] = _createElementVNode("img", {
                                src: "/server/necs/images/icon_update_time.svg",
                                alt: ""
                              }, null, -1)),
                              _createElementVNode("span", null, _toDisplayString(_unref(dayjs)
                      .utc(treatment.modifiedDate)
                      .local()
                      .format("YYYY年M月D日")), 1)
                            ])
                          ])
                        ]))
                      }), 128)),
                      (diseasesWithoutTreatment.value)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(diseasesWithoutTreatment.value, (disease) => {
                            return (_openBlock(), _createElementBlock("li", {
                              class: "treatment-data-contents-item",
                              key: disease.code
                            }, [
                              _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.$t("treatment_label_no_treatment")), 1)
                              ]),
                              _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("div", _hoisted_48, [
                                  _cache[12] || (_cache[12] = _createElementVNode("img", {
                                    src: "/server/necs/images/stethoscope_24dp_5F6368_FILL1_wght400_GRAD0_opsz24.png",
                                    alt: ""
                                  }, null, -1)),
                                  _createElementVNode("p", null, _toDisplayString(disease.name) + _toDisplayString(_ctx.$t("treatment_label_disease_treatment")), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.$t("treatment_label_note")), 1)
                              ])
                            ]))
                          }), 128))
                        : _createCommentVNode("", true)
                    ]))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(Footer, {
          "scroll-target": componentId,
          "active-menu": activeMenu
        })
      ])
    ]),
    (errorDialog.show)
      ? (_openBlock(), _createBlock(ErrorDialog, _mergeProps({ key: 0 }, errorDialog, {
          onOk: errorDialog.close,
          onCancel: errorDialog.close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true),
    (showTreatmentAddModal.value)
      ? (_openBlock(), _createBlock(TreatmentAddEdit, _mergeProps({ key: 1 }, treatmentModalProps, {
          onClose: handleTretmentModalClose,
          onFetchTreatments: fetchTreatments
        }), null, 16))
      : _createCommentVNode("", true),
    (showHistoryModal.value)
      ? (_openBlock(), _createBlock(TreatmentHistory, {
          key: 2,
          diseases: treatmentModalProps.diseaseOptions,
          onClose: handleHistoryModalClose
        }, null, 8, ["diseases"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})